/* global advAppData, buildAppUrl, Vue */
/* eslint no-undef: "error" */

function actionWaitingListSubmit (email, product, token, formBlock) {
  $.ajax({
    type: 'POST',
    url: advAppData.productPage.waitingListAddUri,
    data: { email: email, product: product, 'g-recaptcha-response': token },
    dataType: 'json'
  }).done(function (data, textStatus, jqXHR) {
    let toastedPrintMethod = 'error'
    if (data.status === 'success') {
      toastedPrintMethod = 'success'
      formBlock.fadeOut()
    }
    Vue.$toasted[toastedPrintMethod](data.msg)
  })
}

$(document).ready(function () {
  $('[data-action="waitinglist-form-submit"]').on('click', function () {
    const target = $('#' + $(this).data('target')[0])
    const email = target.val()
    const productId = target.data('product_id')
    const token = $('#g-recaptcha-response').val()
    const formBlock = $('#' + $(this).data('target')[1])
    actionWaitingListSubmit(email, productId, token, formBlock)
  })

  $(document).ready(function () {
    $('#stars .star').on('mouseover', function () {
      const onStar = parseInt($(this).data('value'), 10)
      if (!isNaN(onStar)) {
        $(this).parent().children('.star').each(function (index) {
          index < onStar ? $(this).addClass('hover') : $(this).removeClass('hover')
        })
      }
    }).on('mouseout', function () {
      $(this).parent().children('.star').each(function () {
        $(this).removeClass('hover')
      })
    }).on('click', function () {
      const onStar = parseInt($(this).data('value'), 10)
      if (!isNaN(onStar)) {
        const stars = $(this).parent().children('.star')

        for (let i = 0; i < stars.length; i++) {
          $(stars[i]).removeClass('selected')
        }
        for (let i = 0; i < onStar; i++) {
          $(stars[i]).addClass('selected')
        }
        const ratingValue = parseInt($('#stars .star.selected').last().data('value'), 10)
        ratingValue > 1 ? $('#star_input').val(ratingValue) : $('#star_input').val('')
      }
    })

    $('#review_submit').on('click', function (e) {
      e.preventDefault()
      const ratingValue = $('#star_input').val()
      const recaptchaResponse = $('#g-recaptcha-response-1').val()

      if (!recaptchaResponse) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Please complete the reCAPTCHA.',
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000
        })
        return
      }

      if (ratingValue >= 1) {
        $.ajax({
          type: 'POST',
          url: buildAppUrl(advAppData.uris.submitProductReview),
          dataType: 'json',
          data: {
            product_id: advAppData.productPage.productId,
            review_rating: ratingValue,
            review_name: $('#reviewname').val(),
            review_text: $('#reviewtext').val(),
            'g-recaptcha-response': recaptchaResponse // Include reCAPTCHA response
          },
          complete: function (data) {
            // Update the reviews section based on response status
            if (data.responseJSON.status === '1') {
              $('.reviews-content-wrapper').html('')
              $('.reviews-content-wrapper').html(advAppData.markup.productPageReviewsAjaxResponseSuccess);
              Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Your review has been submitted successfully!',
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
            }
            if (data.responseJSON.status === '0') {
              $('.reviews-content-wrapper').html('')
              $('.reviews-content-wrapper').html(advAppData.markup.productPageReviewsAjaxResponseFail);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'There was a problem submitting your review. Please try again.',
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
            }
          }
        });
      }
    });
  })
})

$(document).ready(function () {
  $('.product-rate-row').on('click', function () {
    $('html, body').animate({
      scrollTop: $('#product-page-tabs').offset().top - 200
    }, 2000)
    $('#product-page-tabs ul.tabs li').removeClass('current')
    $('#product-page-tabs .tab-content').removeClass('current')
    $('#product-page-tabs .tab-content#tab-4').addClass('current')
    $('#product-page-tabs ul.tabs li[data-tab="tab-4"]').addClass('current')
    return false
  })
})

document.addEventListener('DOMContentLoaded', function () {
  function getStickyHeaderHeight () {
    const siteHeaderMain = document.getElementById('site-header-main')
    const headerWrapperSection = document.querySelector('.header-wrapper-section')

    const siteHeaderHeight = siteHeaderMain ? siteHeaderMain.offsetHeight : 0
    const headerWrapperHeight = headerWrapperSection ? headerWrapperSection.offsetHeight : 0
    const total = siteHeaderHeight + headerWrapperHeight
    if (window.matchMedia('(max-width: 768px)').matches) {
      return siteHeaderHeight - 150
    }
    return total
  }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href').substring(1)
      const targetElement = document.getElementById(targetId)

      if (targetElement) {
        e.preventDefault()
        const offset = getStickyHeaderHeight()
        window.scrollTo({
          top: targetElement.offsetTop - offset,
          behavior: 'smooth'
        })
      }
    })
  })
})

document.addEventListener('DOMContentLoaded', function () {
  // Function to check if the screen width corresponds to mobile devices
  function isMobileView () {
    return window.innerWidth <= 768
  }

  const launchButton = document.getElementById('launch-review-write')
  if (launchButton) {
    launchButton.addEventListener('click', function () {
      if (isMobileView()) {
        const reviewsSection = document.getElementById('reviews-section')
        if (reviewsSection) {
          reviewsSection.classList.add('open')
        }

        const mainModalOverlay = document.getElementById('main-modal-overlay')
        if (mainModalOverlay) {
          mainModalOverlay.style.display = 'block'
        }
      }
    })
  }

  const loginToggleButton = document.getElementById('review-login-toggle')
  if (loginToggleButton) {
    loginToggleButton.addEventListener('click', function () {
      const reviewsSection = document.getElementById('reviews-section')
      if (reviewsSection) {
        reviewsSection.classList.remove('open')
      }
    })
  }
})
